import { FC } from 'react';

import { ModalWrapper } from '../../../../components/modal-wrapper/index';
import { popupStore } from '../popup/popup.store';
import { PopupType } from '../popup/popup.types';
import { formStore, PerkFormMode, PerkFormVariant } from './form.store';
import { PerkForm } from './perk-form';

export const PerkFormModal: FC = () => {
  const close = formStore(({ close }) => close);
  const isOpen = formStore(({ isOpen }) => isOpen);
  const formMode = formStore(({ formMode }) => formMode);
  const fromVariant = formStore(({ variant }) => variant);

  const openPopup = popupStore(({ openPopup }) => openPopup);

  return (
    <ModalWrapper
      className="w-full max-w-[485px] p-1"
      control={{ open: isOpen }}
      onBgClick={() => {
        if (formMode === PerkFormMode.VIEW) return close();
        if (formMode === PerkFormMode.EDIT && fromVariant === PerkFormVariant.READ_WITH_EDIT)
          return close();

        openPopup({
          onAcceptCallback: close,
          type:
            formMode === PerkFormMode.CREATE
              ? PopupType.CANCEL_PERK_CREATION
              : PopupType.CANCEL_PERK_EDITING,
        });
      }}
      side="RIGHT"
    >
      <div className="flex h-full w-full flex-col gap-4 overflow-hidden rounded-lg bg-white px-6 pt-3">
        <PerkForm />
      </div>
    </ModalWrapper>
  );
};
